import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export type UpdateProductImagePayload = {
  image: File | null;
  id?: string;
  currentStageId?: string;
};
type UpdateProductImageResponse = any;

export const updateProductImage = async (
  payload: UpdateProductImagePayload
): Promise<UpdateProductImageResponse> => {
  try {
    const formData = new FormData();

    if (payload.image) {
      formData.append('files', payload.image);
    }

    const { data } = await apiService.post<UpdateProductImageResponse>(
      `/products/${payload.id}/${payload.currentStageId}/files/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
